import * as React from 'react';
import { st, classes } from './Divider.deprecated.st.css';
export const Divider = (props) => {
    const { className, direction = 'horizontal', ariaHidden } = props;
    return (React.createElement("hr", { "data-hook": props['data-hook'], className: st(classes.root, { direction }, className), "aria-hidden": ariaHidden }));
};
//# sourceMappingURL=Divider.js.map